import { getIndustryApi } from "@/api/services/admin/learning-content";
import { TopPage } from "@/components/elements/TopPage";
import { IndustryForm } from "@/features/learning-content/components/IndustryForm";
import { convertIndustryResToForm } from "@/features/learning-content/utils/converts";
import { TIndustryForm } from "@/features/learning-content/types/industryForm";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { AppRoutes } from "@/routes/config";
import { Stack, Typography } from "@mui/material";
import { FC, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { styled } from "@mui/system";
import { useQuery } from "@tanstack/react-query";
import { isNumber } from "@/utils/number";
import { useEffect } from "react";

type TIndustryEditPageProps = {};

export const IndustryEditPage: FC<TIndustryEditPageProps> = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const formRef = useRef<{ submit: () => void }>(null);

  const {
    data: industryRes,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [QUERY_KEYS.LEARNING_CONTENT.FETCH_DETAIL, id],
    queryFn: () => getIndustryApi(id!),
    enabled: Boolean(id) && isNumber(id),
  });

  const industryData = industryRes?.data;

  useEffect(() => {
    if (!id || !isNumber(id)) {
      navigate(AppRoutes.learningContent, { replace: true });
    }
  }, [id, navigate]);

  useEffect(() => {
    if (id && isNumber(id) && !isLoading && (isError || !industryData)) {
      navigate(AppRoutes.learningContent, { replace: true });
    }
  }, [id, isLoading, isError, industryData, navigate]);

  const previousData: Partial<TIndustryForm> | undefined = industryData ? convertIndustryResToForm(industryData) : undefined;

  if (isLoading || !industryData) return <LoadingPage />;

  return (
    <PartnerWrapper gap={4}>
      <TopPage
        title={
          <Typography variant="head32Bold" display="flex" alignItems="center" gap={2}>
            分野情報の編集
          </Typography>
        }
        description={
          <Typography variant="body14">
            分野の基本情報を編集できます。試験基本情報は試験シーズンに関わらず共通の設定になるため、実施機関の変更などは書き換える時期にご注意ください。
          </Typography>
        }
        enablePageBack={false}
      />
      <IndustryForm ref={formRef} previousData={previousData} />
    </PartnerWrapper>
  );
};

const PartnerWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
  margin-top: 8px;
`;
